import React from 'react'
import { Box, Heading, Text, Button, Flex } from '@chakra-ui/react'

export const ErrorFallback = ({ error, resetErrorBoundary }) => {
  return (
    <Box p={4} bg="white" borderRadius="md" borderWidth="1px" borderColor="red.300" shadow="md">
      <Heading as="h2" size="md" color="red.500" mb={2}>
        Algo deu errado
      </Heading>
      <Text color="gray.700" mb={4}>
        {error.message || 'Ocorreu um erro ao carregar os agendamentos. Por favor, tente novamente.'}
      </Text>
      <Flex justifyContent="flex-end">
        <Button colorScheme="red" size="sm" onClick={resetErrorBoundary}>
          Tentar novamente
        </Button>
      </Flex>
    </Box>
  )
}
